export default {
  basename: process.env.REACT_APP_ROUTE_BASENAME,
  apiUrl: process.env.REACT_APP_API_URL,
  environment: process.env.REACT_APP_ENVIRONMENT,
};
